var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCare2ULogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HealthCare2u_-_Logo",
    "data-name": "HealthCare2u - Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.451,
    height: 63.484,
    viewBox: "0 0 127.451 63.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Left_Square",
    "data-name": "Bottom Left Square",
    width: 22.112,
    height: 22.551,
    transform: "translate(32.601 40.933)",
    fill: "#9e3223"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Top_Left_Square",
    "data-name": "Top Left Square",
    width: 22.112,
    height: 22.55,
    transform: "translate(32.601)",
    fill: "#9e3223"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Right_Square",
    "data-name": "Bottom Right Square",
    width: 22.112,
    height: 22.551,
    transform: "translate(72.738 40.933)",
    fill: "#9e3223"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Top_Right_Square",
    "data-name": "Top Right Square",
    width: 22.112,
    height: 22.55,
    transform: "translate(72.738)",
    fill: "#9e3223"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "H1",
    d: "M416.488,157.676h2.2v2.6h4.635v-2.6h2.2v7.312h-2.2V162.22h-4.635v2.768h-2.2Z",
    transform: "translate(-416.488 -129.013)",
    fill: "#0d123b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "E1",
    d: "M424.009,157.676h7.844v1.7h-5.645v1.172h5.348v1.515h-5.348v1.172h5.773v1.757h-7.972Z",
    transform: "translate(-412.501 -129.013)",
    fill: "#0d123b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M434.156,157.676h2.863l3.942,7.312h-2.447l-.682-1.294h-4.457l-.644,1.294h-2.456Zm.04,4.444h2.812l-1.426-2.748Z",
    transform: "translate(-409.179 -129.013)",
    fill: "#0d123b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M438.416,157.676h2.2v5.434h4.942v1.879h-7.141Z",
    transform: "translate(-404.863 -129.013)",
    fill: "#0d123b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M443.278,157.676h8.379v1.818h-3.091v5.494h-2.2v-5.494h-3.089Z",
    transform: "translate(-402.285 -129.013)",
    fill: "#0d123b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "H2",
    d: "M450.028,157.676h2.2v2.6h4.635v-2.6h2.2v7.312h-2.2V162.22h-4.635v2.768h-2.2Z",
    transform: "translate(-398.707 -129.013)",
    fill: "#0d123b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M457.445,160.271c0-2.143,1.18-2.647,3.16-2.647h2.586c3.129,0,3.536.687,3.516,2.757h-2.2v-.2c0-.524-.375-.676-1.03-.676h-2.4c-1.158,0-1.377.556-1.377,1.464v.788c0,1.061.219,1.465,1.258,1.465h2.347c.992,0,1.288-.1,1.288-1.011h2.2v.687c0,1.233-.436,2.2-2.644,2.2H460.6c-1.98,0-3.16-.506-3.16-2.647Z",
    transform: "translate(-394.774 -129.042)",
    fill: "#0d123b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M468.494,157.676h2.861l3.942,7.312H472.85l-.682-1.294H467.71l-.643,1.294H464.61Zm.038,4.444h2.814l-1.426-2.748Z",
    transform: "translate(-390.976 -129.013)",
    fill: "#0d123b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M472.752,157.676h6.636c1.694,0,2.15.858,2.15,2.171v.465c0,.98-.219,1.556-1.229,1.8v.02c.653.122,1.2.414,1.2,1.617v1.242h-2.2v-.879c0-.768-.217-1.021-.9-1.021h-3.457v1.9h-2.2Zm2.2,3.6h3.636c.594,0,.813-.242.813-.768v-.242c0-.648-.318-.768-1.011-.768h-3.437Z",
    transform: "translate(-386.659 -129.013)",
    fill: "#0d123b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "E2",
    d: "M480.111,157.676h7.845v1.7H482.31v1.172h5.348v1.515H482.31v1.172h5.775v1.757h-7.974Z",
    transform: "translate(-382.758 -129.013)",
    fill: "#0d123b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M486.8,160.475c0-.9.575-1.495,1.992-1.6l2.514-.162c1.605-.1,1.714-.131,1.714-.847,0-.6-.058-.727-1.466-.727H490.1c-.93,0-1.218.14-1.218.9v.312H486.8v-.858c0-1.443.832-1.929,2.814-1.929h2.892c2.06,0,2.6.626,2.6,2.152,0,2.15-.387,2.514-2.952,2.656l-2.269.122c-.92.05-1.059.231-1.059.888H495.2v1.576h-8.4Z",
    transform: "translate(-379.21 -130.196)",
    fill: "#9e3223"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M493.878,157.676h2.2V161.9c0,.93.326,1.294,1.227,1.294h2.179c.9,0,1.229-.364,1.229-1.294v-4.221h2.2v4.706c0,1.818-.921,2.687-2.943,2.687h-3.149c-2.021,0-2.941-.869-2.941-2.687Z",
    transform: "translate(-375.459 -129.013)",
    fill: "#0d123b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCare2ULogo);
export default __webpack_public_path__ + "static/media/HealthCare2uLogo.15ee7b538953418c8bc92d9b97716ce2.svg";
export { ForwardRef as ReactComponent };